export const DEFAULT_SIZE = 'm';
export const sizeValues = ['l', 'm', 's'];
export const sizeExValues = [...sizeValues, 'xs'];